const state = {
  options: {
    isSale: false,
    products: {
      key: '123'
    },
    attendee: {
      wgmk2s6is: {
        id: 1,
        uid: 'wgmk2s6is',
        userValue: '',
        isActive: false,
        isUnique: false,
        filedName: 'fullName',
        filedTitle: '姓名',
        type: 'input',
        filedType: 'system',
        isNecessary: true,
        isShow: true,
        placeholder: '请填写姓名',
        hasDescription: true,
        description: '这里是描述文字内容',
        isRelation: false,
        relationFiled: undefined,
        relationType: undefined,
        relationValue: '',
        isCheck: false,
        checkTypeName: undefined,
        checkType: ''
      },
      ltsqxeyr0: {
        id: 2,
        uid: 'ltsqxeyr0',
        userValue: '',
        isActive: false,
        isUnique: false,
        filedName: 'phoneNumber',
        filedTitle: '手机',
        type: 'phone',
        filedType: 'system',
        isNecessary: true,
        isShow: true,
        placeholder: '请填写手机号码',
        hasDescription: true,
        description: '这里是描述文字内容',
        isRelation: false,
        relationFiled: undefined,
        relationType: undefined,
        relationValue: '',
        isSMSverification: false,
        SMSsurplus: 3,
        isCheck: true,
        checkTypeName: '手机号',
        checkType: 'phone'
      },
      sx0md19tp: {
        id: 3,
        uid: 'sx0md19tp',
        userValue: '',
        isActive: false,
        isUnique: false,
        filedName: 'email',
        filedTitle: '邮箱',
        type: 'email',
        filedType: 'system',
        isNecessary: true,
        isShow: true,
        placeholder: '请填写邮箱',
        hasDescription: false,
        description: '这里是描述文字内容',
        isRelation: false,
        relationFiled: undefined,
        relationType: undefined,
        relationValue: '',
        isCheck: true,
        checkTypeName: '邮箱',
        checkType: 'email'
      },
      '7nd026yxd': {
        id: 4,
        uid: '7nd026yxd',
        userValue: '',
        isActive: false,
        isUnique: false,
        filedName: 'picture',
        filedTitle: '照片上传',
        type: 'avatar',
        icon: 'user',
        filedType: 'system',
        isNecessary: false,
        isShow: true,
        placeholder: '仅支持上传带有人像的照片，.png .jpg 格式，5M 大小文件',
        hasDescription: false,
        description: '这里是描述文字内容',
        isRelation: false,
        relationFiled: undefined,
        relationType: undefined,
        relationValue: ''
      },
      b6yxs027b: {
        id: 5,
        uid: 'b6yxs027b',
        userValue: '',
        isActive: false,
        isUnique: false,
        filedName: 'IDnumber',
        filedTitle: '身份证号',
        type: 'input',
        filedType: 'system',
        isNecessary: true,
        isShow: true,
        placeholder: '请填写身份证号',
        hasDescription: false,
        description: '这里是描述文字内容',
        isRelation: false,
        relationFiled: undefined,
        relationType: undefined,
        relationValue: '',
        isCheck: true,
        checkTypeName: '身份证号码',
        checkType: 'idNumber'
      },
      '7nd026zzh': {
        id: 6,
        uid: '7nd026zzh',
        userValue: '',
        isActive: false,
        isUnique: false,
        filedName: 'SingleLineInp',
        filedTitle: '单行输入',
        type: 'input',
        filedType: 'common',
        isNecessary: false,
        isShow: true,
        placeholder: '请填写单行文本',
        hasDescription: false,
        description: '这里是描述文字内容',
        isRelation: false,
        relationFiled: undefined,
        relationType: undefined,
        relationValue: '',
        isCheck: true,
        checkTypeName: undefined,
        checkType: 'digit'
      },
      wgmk2ujhm: {
        id: 7,
        uid: 'wgmk2ujhm',
        userValue: '',
        isActive: false,
        isUnique: false,
        filedName: 'multilineInput',
        filedTitle: '多行输入',
        type: 'textarea',
        filedType: 'common',
        isNecessary: false,
        isShow: true,
        placeholder: '请填写多行文本',
        hasDescription: false,
        description: '这里是描述文字内容',
        isRelation: false,
        relationFiled: undefined,
        relationType: undefined,
        relationValue: ''
      },
      eqkvhtleb: {
        id: 8,
        uid: 'eqkvhtleb',
        userValue: '',
        isActive: false,
        isUnique: false,
        filedName: 'radio',
        filedTitle: '单选框',
        type: 'radio',
        filedType: 'common',
        isNecessary: false,
        isShow: true,
        hasDescription: false,
        description: '这里是描述文字内容',
        isRelation: false,
        relationFiled: undefined,
        relationType: undefined,
        relationValue: '',
        optionList: [
          {
            id: 1,
            label: 'radio1',
            value: '单选项 1'
          },
          {
            id: 2,
            label: 'radio2',
            value: '单选项 2'
          },
          {
            id: 3,
            label: 'radio3',
            value: '大量数据展示，想要查看数据较多时该行数据在页面展示的效果'
          }
        ]
      },
      ltsqxg334: {
        id: 9,
        uid: 'ltsqxg334',
        userValue: [],
        isActive: false,
        isUnique: false,
        filedName: 'checkbox',
        filedTitle: '多选框',
        type: 'checkbox',
        filedType: 'common',
        isNecessary: false,
        isShow: true,
        hasDescription: false,
        description: '这里是描述文字内容',
        isRelation: true,
        relationFiled: 'eqkvhtleb',
        relationType: 'equal',
        relationValue: '单选项 1',
        optionList: [
          {
            id: 1,
            label: false,
            value: '多选项 1'
          },
          {
            id: 2,
            label: false,
            value: '多选项 2'
          },
          {
            id: 3,
            label: false,
            value: '大量数据展示，想要查看数据较多时该行数据在页面展示的效果'
          }
        ]
      },
      ia6t7n6o5: {
        id: 10,
        uid: 'ia6t7n6o5',
        userValue: '',
        isActive: false,
        isUnique: false,
        filedName: 'select',
        filedTitle: '下拉选项',
        type: 'select',
        filedType: 'common',
        isNecessary: false,
        isShow: true,
        placeholder: '请选择',
        hasDescription: false,
        description: '这里是描述文字内容',
        isRelation: false,
        relationFiled: undefined,
        relationType: undefined,
        relationValue: '',
        optionList: [
          {
            id: 1,
            label: 'select1',
            value: '下拉选项 1'
          },
          {
            id: 2,
            label: 'select2',
            value: '下拉选项 2'
          },
          {
            id: 3,
            label: 'select3',
            value: '大量数据展示，想要查看数据较多时该行数据在页面展示的效果'
          }
        ]
      },
      b6yxs1950: {
        id: 11,
        uid: 'b6yxs1950',
        userValue: '',
        isActive: false,
        isUnique: false,
        filedName: 'imageUpload',
        filedTitle: '图片上传',
        type: 'image',
        icon: 'picture',
        filedType: 'common',
        isNecessary: false,
        isShow: true,
        placeholder: '仅支持上传.png .jpg 格式， 5M 大小文件',
        hasDescription: false,
        description: '这里是描述文字内容',
        isRelation: false,
        relationFiled: undefined,
        relationType: undefined,
        relationValue: ''
      },
      pdeon9s40: {
        id: 12,
        uid: 'pdeon9s40',
        userValue: '',
        isActive: false,
        isUnique: false,
        filedName: 'fileUpload',
        filedTitle: '文件上传',
        type: 'file',
        filedType: 'common',
        isNecessary: false,
        isShow: true,
        placeholder: '仅支持上传 5M 大小文件',
        hasDescription: false,
        description: '这里是描述文字内容',
        isRelation: false,
        relationFiled: undefined,
        relationType: undefined,
        relationValue: ''
      },
      wgmk2w2b9: {
        id: 13,
        uid: 'wgmk2w2b9',
        userValue: '',
        isActive: false,
        isUnique: false,
        filedName: 'date',
        filedTitle: '日期时间',
        type: 'date',
        filedType: 'common',
        isNecessary: false,
        isShow: true,
        placeholder: '请选择',
        hasDescription: false,
        description: '这里是描述文字内容',
        isRelation: true,
        relationFiled: 'ia6t7n6o5',
        relationType: 'equal',
        relationValue: '下拉选项 1',
        dataStyle: '年-月-日 时:分'
      },
      '43r2cfn1r': {
        id: 14,
        uid: '43r2cfn1r',
        userValue: '',
        isActive: false,
        isUnique: false,
        filedName: 'area',
        filedTitle: '省市区',
        type: 'area',
        filedType: 'common',
        isNecessary: false,
        isShow: true,
        placeholder: '请选择',
        hasDescription: false,
        description: '这里是描述文字内容',
        isRelation: true,
        relationFiled: 'ia6t7n6o5',
        relationType: 'equal',
        relationValue: '下拉选项 2',
        dataStyle: '省市区'
      },
      pdeona9jm: {
        id: 15,
        uid: 'pdeona9jm',
        userValue: '',
        isActive: false,
        isUnique: false,
        filedName: 'digit',
        filedTitle: '数字',
        type: 'digit',
        filedType: 'common',
        isNecessary: false,
        isShow: true,
        placeholder: '请填写数字',
        hasDescription: true,
        description: '数字组件主要用于移动端输入，自动使用数字键盘',
        isRelation: false,
        relationFiled: undefined,
        relationType: undefined,
        relationValue: '',
        isCheck: true,
        checkTypeName: '数字',
        checkType: 'digit'
      },
      '43r2cfy4v': {
        id: 16,
        uid: '43r2cfy4v',
        userValue: '',
        isActive: true,
        isUnique: false,
        filedName: 'Mark',
        filedTitle: '备注',
        type: 'input',
        filedType: 'common',
        isNecessary: false,
        isShow: true,
        placeholder: '请填写备注信息',
        hasDescription: false,
        description: '这里是描述文字内容',
        isRelation: false,
        relationValue: '18333630910',
        relationFiled: '手机',
        relationType: '等于'
      }
    }
  },
  pickProducts: [
    {
      id: 1
    }
  ]
}

const getters = {
  // 读取表单配置
  getOptions(state) {
    return state.options
  },
  // 读取购票信息
  getProducts(state) {
    return state.pickProducts
  },
  // 读取是否售卖
  getSaleStatus(state) {
    return state.options.isSale
  }
}

const mutations = {
  // 设置当前表单配置
  modifyOptions(state, option) {
    state.options = option
  },
  // 修改当前购票信息
  modifypickProducts(state, product) {
    state.pickProducts = product
  },
  // 修改售卖状态
  modifyisSale(state, status) {
    state.isSale = status
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
